import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { ReactComponent as InfoOutlined } from '../../assets/icons/info-outlined.svg';

const StatementsGuide = () => {
    const { formatMessage } = useIntl();

    return (
        <div className="statements-guide">
            <InfoOutlined className="statements-info-outlined" data-testid="statements-guide-icon" />
            <h3 className="statements-question-wrapper">
                <FormattedMessage id="statements.question.guide" />
            </h3>
            <div className="statements-guide-link-wrapper">
                <a
                    className="statements-guide-link-text"
                    href={formatMessage({ id: 'statements.guide.url' })}
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    <FormattedMessage id="statements.guide.link" />
                </a>
            </div>
        </div>
    );
};

export default StatementsGuide;
